export default "__VITE_ASSET__fbf15d72__"